/**
 * @author       chenzhongyi <chenzhongyi@tuzhanai.com>
 * @copyright    2018 Zhongyi Chen.
 */

/**
 * 为特定url增删search参数
 * 
 * @param {string} url 需要处理的url地址
 * @param {Array} delParams 需要删除的search参数的key集合
 * @param {Object} newParams 需要新增的search参数键值对集合
 * 
 * @return {string} 完成增删search参数后的新url
 */
export default function filterUrl(url, delParams, newParams) {
  url = url.split('#')[0];      // 先去掉 hash
  delParams = delParams || [];
  newParams = newParams || {};

  let urlArr = url.split('?');
  let origin = urlArr[0];
  let search = urlArr[1] || '';

  let queryArr = search.split('&');
  let query = {};

  for (let i = 0; i < queryArr.length; i++) {
    if (queryArr[i].length > 0) {
      let temp = queryArr[i].split('=');

      query[temp[0]] = temp[1];
    }
  }

  let newSearch = '';

  for (let key in newParams) {
    query[key] = newParams[key];
  }
  for (let key in query) {
    if (delParams.indexOf(key) !== -1) {
      continue;
    }
    newSearch = newSearch + encodeURIComponent(key) + '=' + encodeURIComponent(query[key]) + '&';
  }
  newSearch = newSearch.replace(/&{1}$/, '');

  if (newSearch.length > 0) newSearch = '?' + newSearch;

  let href = origin + newSearch + location.hash;

  return href;
}
